import dayjs from 'dayjs';
import { currencyFormatter, getInvoiceStatus } from '../../../utils/utils';

export const normalizeInvoiceData = (data) => {
  const dataSource = data.map((item, index) => {
    const { statusLabel, statusColor } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      oper_fcanc_id: item.oper_fcanc_id
    });
    return {
      key: `${item.oper_id}_${index}`,
      oper_id: item.oper_id,
      oper_clie_id: item.oper_clie_id,
      oper_uuid: item.oper_uuid,
      oper_cates_id_int: item.oper_cates_id_int,
      'Num. Oper.': item.oper_id,
      'Folio': item.cfiscal_codbar,
      'Fecha Oper.': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      'Forma Pago': item.forma_pago,
      'Mét. Pago': item.metodo_pago,
      status: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion,
      cates_descripcion_str: item.cates_descripcion_str,
      estado: statusLabel,
      estado_color: statusColor,
      motivo_descripcion: item.motivo_descripcion
    };
  });

  // RFC, numero operacion, fecha, tipo, total, forma pago, metodo pago, estado
  const columns = [
    { title: 'Num. Oper.', dataIndex: 'Num. Oper.', key: 'Num. Oper.', className: 'col-num_oper', width: 70 },
    { title: 'Folio', dataIndex: 'Folio', key: 'Folio', className: 'col-folio', width: 100 },
    { title: 'RFC', dataIndex: 'RFC', key: 'RFC', className: 'col-rfc', width: 120 },
    { title: 'Fecha Oper.', dataIndex: 'Fecha Oper.', key: 'Fecha Oper.', className: 'col-fecha_oper', width: 100 },
    { title: 'Tipo', dataIndex: 'Tipo', key: 'Tipo', className: 'col-tipo', width: 80 },
    { title: 'Total', dataIndex: 'Total', key: 'Total', className: 'col-total', width: 100 },
  ];

  return { dataSource, columns };
};

export const normalizeInvoiceDataForExport = (data) => {
  return data.map((item) => {
    const { statusLabel } = getInvoiceStatus({
      oper_facturado: item.oper_facturado,
      efact_descripcion: item.efact_descripcion,
      errtim_descripcion: item.errtim_descripcion,
      oper_fcanc_id: item.oper_fcanc_id
    });
    return {
      'Número de operación': item.oper_id,
      'Fecha de operación': dayjs(item.oper_fecha).format('DD-MM-YYYY'),
      Tipo: item.oper_tipo_operacion === 1 ? 'Boletaje' : 'Pensiones',
      Total: currencyFormatter(item.oper_total),
      RFC: item.clie_rfc,
      'Forma Pago': item.forma_pago,
      'Mét. Pago': item.metodo_pago,
      Motivo: item.motivo_descripcion,
      Estado: statusLabel,
      'Descripción del estado': item.errtim_descripcion
    };
  });
};
